export enum ToastType {
  SUCCESS = "success",
  FAILURE = "failure",
}

export interface BaseTypeProps {
  $type: ToastType;
}

export interface ProgressBarProps extends BaseTypeProps  {
  $width: number;
}

export interface ToastProps {
  type: ToastType;
  message: string;
  duration?: number;
  onClose: () => void;
  showCloseIcon?: boolean;
  actionHandler?: () => void;
  actionText?: string;
}